import * as React from "preact";
import { JSX } from "preact";

export interface IconContext {
  color?: string;
  size?: string;
  class?: string;
  stroke?: string | JSX.SignalLike<string | undefined>; // allow overide stroke color "currentColor"
  fill?: string | JSX.SignalLike<string | undefined>; // allow overide fill color "currentColor"
  strokeWidth?:  number | string | JSX.SignalLike<number | string | undefined>; // allow overide strokeWidth default 0

  style?: JSX.CSSProperties;
  attr?: JSX.SVGAttributes<SVGSVGElement>;
}

export const defaultContext: IconContext = {
  color: undefined,
  size: undefined,
  class: undefined,
  style: undefined,
  attr: undefined,
};

export const defaultIconContext: React.Context<IconContext> = React.createContext && React.createContext(defaultContext);

// denoCacheMetadata={"headers":{"age":"80828","alt-svc":"h3=\":443\"; ma=86400","x-jsd-version":"1.0.8","x-content-type-options":"nosniff","cross-origin-resource-policy":"cross-origin","content-type":"text/plain; charset=utf-8","report-to":"{\"endpoints\":[{\"url\":\"https:\\/\\/a.nel.cloudflare.com\\/report\\/v4?s=jOjCiXOo7kYRVoeXe23iiajfwiWN7FPlEl3yDil0oRzRCf6yb%2BWT6W6jL2vYKzSvZ%2FotkmsWhoH50dvtq7uDYgKfhD0JCiDFCNYvaiqStPhf%2BTYkx3rOehkhnG5%2Fqeg%2Bc00%3D\"}],\"group\":\"cf-nel\",\"max_age\":604800}","x-jsd-version-type":"version","etag":"W/\"32a-Bmotoc1mE42JAxp+yFUNnwalsPg\"","cf-cache-status":"HIT","access-control-expose-headers":"*","cache-control":"public, max-age=31536000, s-maxage=31536000, immutable","cf-ray":"9179ab650c21679c-SJC","strict-transport-security":"max-age=31536000; includeSubDomains; preload","timing-allow-origin":"*","x-cache":"HIT, HIT","nel":"{\"success_fraction\":0.01,\"report_to\":\"cf-nel\",\"max_age\":604800}","x-served-by":"cache-fra-etou8220096-FRA, cache-lga21942-LGA","date":"Tue, 25 Feb 2025 18:13:28 GMT","accept-ranges":"bytes","access-control-allow-origin":"*","server":"cloudflare","vary":"Accept-Encoding"},"url":"https://cdn.jsdelivr.net/gh/urielch/react-icons@1.0.8/lib/iconContext.ts","time":1740507208}